export default "__VITE_ASSET__fca91446__"